import script from "./TransactionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionCard.vue?vue&type=script&setup=true&lang=js"

import "./TransactionCard.vue?vue&type=style&index=0&id=72e39b50&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e39b50"]])

export default __exports__